<!-- 物流运输单提货信息部分 -->
<template>
  <div class="pickUpForm">
    <el-form
      :model="pickUpData"
      :rules="pickUpDataRules"
      ref="pickUpForm"
      label-width="120px"
      :disabled="status == '3' || status == '4'"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.deliveryStartDate')"
            prop="deliveryStartDate"
          >
            <el-date-picker
              class="widthStyle"
              v-model="pickUpData.deliveryStartDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :placeholder="this.$t('transportOrderAdd.pickUpForm.deliveryStartDatePlaceholder')"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupStorageName')"
            prop="pickupStorageName"
          >
            <SearchModal
              ref="SearchModal"
              :API="wareName.API"
              className="customer-search"
              :extraData="wareName.extraData || {}"
              :query="wareName.query"
              :searchColumns="wareName.searchColumns"
              :columnList="wareName.columnList"
              :placeholder="$t('search.choose')"
              :width="'800'"
              :propCode="wareName.propCode"
              :propName="wareName.propName"
              :currentValue="wareName.currentValue || null"
              :checkRowKeys="wareName.checkRowKeys"
              :isMultiple="true"
              @setSearchModal="setPickupStorage"
              @setSearchModalInput="setSearchModalInput"
              :isReadOnly="false"
            ></SearchModal>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupStorageAddress')"
            prop="pickupStorageAddress"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.pickUpForm.pickupStorageAddressPlaceholder')"
              v-model="pickUpData.pickupStorageAddress"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupContactPerson')"
            prop="pickupContactPerson"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.pickUpForm.pickupContactPersonPlaceholder')"
              v-model="pickUpData.pickupContactPerson"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupContactTelephone')"
            prop="pickupContactTelephone"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.pickUpForm.pickupContactTelephonePlaceholder')
              "
              v-model="pickUpData.pickupContactTelephone"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupStorageTelephone')"
            prop="pickupStorageTelephone"
          >
            <el-input
              :placeholder="
                this.$t('transportOrderAdd.pickUpForm.pickupStorageTelephonePlaceholder')
              "
              v-model="pickUpData.pickupStorageTelephone"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupStorageArea')"
            prop="pickupStorageArea"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.pickUpForm.pickupStorageAreaPlaceholder')"
              v-model="pickUpData.pickupStorageArea"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupEntity')"
            prop="pickupEntity"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.pickUpForm.pickupEntityPlaceholder')"
              v-model="pickUpData.pickupEntity"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="this.$t('transportOrderAdd.pickUpForm.pickupMark')"
            prop="pickupMark"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.pickUpForm.pickupMarkPlaceholder')"
              v-model="pickUpData.pickupMark"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import COMPANY_API from '@/api/masterData/company';
  import { dateFormatter } from '@/common/js/util';

  export default {
    name: 'pickUpForm',
    components: {
      SearchModal,
    },
    props: ['isEdit', 'allDetail', 'status'],
    mounted() {},
    computed: {
      pickUpDataRules() {
        return {
          deliveryStartDate: [
            {
              required: true,
              message: this.$t('transportOrderAdd.pickUpForm.deliveryStartDatePlaceholder'),
              trigger: 'change',
            },
          ],
          pickupStorageName: [
            {
              required: true,
              message: this.$t('transportOrderAdd.pickUpForm.pickupStorageNamePlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
          pickupStorageAddress: [
            {
              required: true,
              message: this.$t('transportOrderAdd.pickUpForm.pickupStorageAddressPlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      wareName() {
        return {
          API: COMPANY_API.GET_STORAGE_LIST,
          query: {
            storageCode: '',
            storageName: '',
          },
          propCode: 'storageCode',
          propName: 'storageName',
          currentValue: this.pickUpData.pickupStorageName,
          checkRowKeys: [],
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
          ],
        };
      },
      wareAddress() {
        return {
          API: COMPANY_API.GET_STORAGE_LIST,
          query: {
            storageCode: '',
            storageName: '',
          },
          propCode: 'storageCode',
          propName: 'storageAddress',
          currentValue: this.pickUpData.pickupStorageAddress,
          checkRowKeys: [this.pickUpData.pickupStorageNo],
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.storageAddress'),
              prop: 'storageAddress',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
          ],
        };
      },
      wareTel() {
        return {
          API: COMPANY_API.GET_STORAGE_LIST,
          query: {
            storageCode: '',
            storageName: '',
          },
          propCode: 'storageCode',
          propName: 'contactTelephone',
          currentValue: this.pickUpData.pickupStorageTelephone,
          checkRowKeys: [],
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'contactTelephone',
              label: this.$t('warehouse.table.contractTelephone'),
            },
          ],
        };
      },
    },
    data() {
      return {
        // 顶部表单
        pickUpData: {
          deliveryStartDate: dateFormatter(new Date()),
          pickupStorageNo: '',
          pickupStorageName: '',
          pickupStorageAddress: '',
          pickupEntity: '',
          pickupContactPerson: '',
          pickupContactTelephone: '',
          pickupStorageTelephone: '',
          pickupStorageArea: '',
          pickupMark: '',
        },
      };
    },
    methods: {
      getDeatil(allDetail) {
        if (this.status != 0) {
          let pickUpData = {};
          Object.keys(this.pickUpData).forEach((item) => {
            pickUpData[`${item}`] = allDetail.delivery[`${item}`] || '';
          });
          this.pickUpData = pickUpData;
          this.$nextTick(() => {
            this.$refs.pickUpForm.clearValidate();
          });
        }
      },
      setPickupStorage(type, row) {
        this.pickUpData.pickupStorageName = row ? row[0].storageName : '';
        this.pickUpData.pickupStorageNo = row ? row[0].storageCode : '';
        this.pickUpData.pickupStorageAddress = row ? row[0].storageAddress : '';
        this.pickUpData.pickupStorageTelephone = row ? row[0].contactTelephone : '';
      },
      //手动输入时
      setSearchModalInput(model, val) {
        this.pickUpData.pickupStorageName = val;
      },
      // 选择各种单号后带出的详情
      getChooseDetail(obj) {
        let pickUpData = {};
        if (obj.detail) {
          Object.keys(this.pickUpData).forEach((item) => {
            pickUpData[`${item}`] = obj.detail[`${item}`] || this.pickUpData[`${item}`];
          });
        } else {
          pickUpData = this.pickUpData;
          pickUpData.pickupStorageNo = '';
          pickUpData.pickupStorageName = '';
          pickUpData.pickupStorageAddress = '';
          pickUpData.pickupStorageTelephone = '';
          pickUpData.pickupContactPerson = '';
          pickUpData.pickupContactTelephone = '';
        }
        this.pickUpData = pickUpData;
      },
      // 返回数据
      exportChildData(btnType) {
        if (btnType == '4') {
          let sign = false;
          this.$refs.pickUpForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.pickUpData : false;
        } else {
          return this.pickUpData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .pickUpForm .widthStyle {
    width: 100%;
  }
</style>
